/**
 * 登录页面
 */
export default {
  /**
   * 登录页面 form 框上方文字
   */
  title: '欢迎使用AI Tracking',
  form: {
    username: {
      /**
       * 用户名输入框 无文字时的提示
       */
      placement: '请输入用户名',
      /**
       * 用户名输入不正确时的提示
       */
      error: '用户名不正确',
    },
    password: {
      /**
       * 密码输入框 无文字时的提示
       */
      placement: '请输入密码',
      /**
       * 密码输入不正确时的提示
       */
      error: '密码不正确',
    },
    captcha: {
      /**
       * 验证码输入框 无文字时的提示
       */
      placement: '请输入验证码',
      /**
       * 验证码输入不正确时的提示
       */
      error: '验证码不正确',
    },
    button: {
      /**
       * 登录按钮的文字
       */
      text: '登录',
    },
  },
  login: '登录',
  remeber: '记住我',
  loginSuccess: '已成功登录并立即进入系统',
  loginAgain: '由于您长时间未操作请再次登录后继续上次操作',
  checkCaptcha: '请检查验证码',
  loginWrong: '账号或密码错误',
  loginExpired: '账号已过期，请您与杰西卡商务部联系：bd@jescard.com',
  loginFail: '登录失败',
};
